import React from "react";
import Countdown from "react-countdown";
import { makeStyles } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  timerContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    width: "50%",
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
    [theme.breakpoints.down("xs")]: {
      flexDirection: "row",
    },
    margin: "0rem 0rem 1rem 0rem",
  },
  timerInnerContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-around",
    alignItems: "center",
    width: "100%",
  },
  timerInner: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
  },
  timerNumber: {
    fontWeight: 300,
    fontSize: "4rem",
    [theme.breakpoints.down("xs")]: {
      fontSize: "2rem",
      lineHeight: "3rem",
    },
    lineHeight: "6rem",
    textAlign: "center",
  },
  timerText: {
    fontWeight: 500,
    fontSize: "1rem",
    [theme.breakpoints.down("xs")]: {
      fontSize: "0.8rem",
    },
    lineHeight: "1.5rem",
    textAlign: "center",
  },
}));

const Completionist = () => <span>You are good to go!</span>;

// Renderer callback with condition
const Renderer = (props) => {
  const classes = props.props.classes;
  if (props.completed) {
    // Render a completed state
    return <Completionist />;
  } else {
    // Render a countdown
    return (
      <React.Fragment>
        <div className={classes.timerContainer}>
          <div className={classes.timerInnerContainer}>
            <div className={classes.timerInner}>
              <Typography
                className={classes.timerNumber}
                variant="h6"
                component="span"
              >
                {props.days}
              </Typography>
              <Typography
                className={classes.timerText}
                variant="h6"
                component="span"
              >
                Days
              </Typography>
            </div>
            <div className={classes.timerInner}>
              <Typography
                className={classes.timerNumber}
                variant="h6"
                component="span"
              >
                {props.hours}
              </Typography>
              <Typography
                className={classes.timerText}
                variant="h6"
                component="span"
              >
                Hours
              </Typography>
            </div>
          </div>
          <div className={classes.timerInnerContainer}>
            <div className={classes.timerInner}>
              <Typography
                className={classes.timerNumber}
                variant="h6"
                component="span"
              >
                {props.minutes}
              </Typography>
              <Typography
                className={classes.timerText}
                variant="h6"
                component="span"
              >
                Minutes
              </Typography>
            </div>
            <div className={classes.timerInner}>
              <Typography
                className={classes.timerNumber}
                variant="h6"
                component="span"
              >
                {props.seconds}
              </Typography>
              <Typography
                className={classes.timerText}
                variant="h6"
                component="span"
              >
                Seconds
              </Typography>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
};

const CountDown = (props) => {
  const classes = useStyles();
  return (
    <React.Fragment>
      <Countdown
        date={
          props.endDate
            ? new Date(props.endDate).getTime()
            : new Date().getTime()
        }
        renderer={Renderer}
        classes={classes}
      />
    </React.Fragment>
  );
};

export default CountDown;
